var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToExpire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 39,
    viewBox: "0 0 34 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2528 30.0392H2.9489C2.62287 30.0392 2.30137 29.8994 2.05781 29.6358C1.81301 29.3708 1.66936 29.0036 1.66936 28.6133V2.20104C1.66936 1.81068 1.81301 1.44348 2.0578 1.17855C2.30137 0.914956 2.62287 0.775146 2.9489 0.775146H21.2528C21.5788 0.775146 21.9003 0.914955 22.1439 1.17855C22.3887 1.44348 22.5323 1.81068 22.5323 2.20104V28.6133C22.5323 29.0036 22.3887 29.3708 22.1439 29.6358C21.9003 29.8994 21.5788 30.0392 21.2528 30.0392Z",
    fill: "white",
    stroke: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9489 0.550255C2.54436 0.550255 2.15638 0.724174 1.87033 1.03375C1.58428 1.34333 1.42357 1.76321 1.42357 2.20102V28.6133C1.42357 29.0511 1.58428 29.471 1.87033 29.7805C2.15638 30.0901 2.54436 30.264 2.9489 30.264H21.2528C21.6573 30.264 22.0453 30.0901 22.3314 29.7805C22.6174 29.471 22.7781 29.0511 22.7781 28.6133V2.20102C22.7781 1.76321 22.6174 1.34333 22.3314 1.03375C22.0453 0.724174 21.6573 0.550255 21.2528 0.550255H2.9489ZM2.9489 0H21.2528C21.7922 0 22.3095 0.231893 22.6909 0.644664C23.0723 1.05744 23.2866 1.61727 23.2866 2.20102V28.6133C23.2866 29.197 23.0723 29.7569 22.6909 30.1696C22.3095 30.5824 21.7922 30.8143 21.2528 30.8143H2.9489C2.40951 30.8143 1.89221 30.5824 1.51081 30.1696C1.1294 29.7569 0.915131 29.197 0.915131 28.6133V2.20102C0.915131 1.61727 1.1294 1.05744 1.51081 0.644664C1.89221 0.231893 2.40951 0 2.9489 0V0Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40516 21L19.8933 21",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40516 17L19.8933 17",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40516 13L19.8933 13",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1493 9H19.8933",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40516 25L19.8933 25",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.93714,
    y: 4.5,
    width: 4.80807,
    height: 5,
    stroke: "#A3A3A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3549 11.8058C19.5457 11.4644 20.037 11.4644 20.2278 11.8058L30.679 30.5061C30.8653 30.8394 30.6244 31.25 30.2426 31.25H9.34014C8.95834 31.25 8.71741 30.8394 8.90368 30.5061L19.3549 11.8058Z",
    fill: "white",
    stroke: "#A3A3A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3393 17.452C18.3393 16.6501 18.9894 16 19.7914 16C20.5933 16 21.2434 16.6501 21.2434 17.452V24.548C21.2434 25.3499 20.5933 26 19.7914 26C18.9894 26 18.3393 25.3499 18.3393 24.548V17.452Z",
    fill: "#A3A3A3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1466 28.4499C21.1466 27.6491 20.5181 26.9999 19.743 26.9999C18.9678 26.9999 18.3393 27.6491 18.3393 28.4499C18.3393 29.2507 18.9678 29.8999 19.743 29.8999C20.5181 29.8999 21.1466 29.2507 21.1466 28.4499Z",
    fill: "#A3A3A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToExpire);
export default __webpack_public_path__ + "static/media/to-expire.b1f540628cab30edf24e4b935ee5873a.svg";
export { ForwardRef as ReactComponent };